import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';

onPageLoad(() => {
  $(document).on($.modal.CLOSE, '.modal--change-status', () => {
    $('.modal--change-status').remove();
  });
});
